import { styled } from '@mui/material'
import ExternalLink from '@mui/material/Link'

const BlackText = styled(ExternalLink)(({ theme }) => ({
  marginTop: 12,
  fontWeight: 600,
  display: 'block',
  color: '#202CD3',
  textDecoration: 'none',
  textAlign: 'center',
  fontSize: '0.875rem',
  [theme.breakpoints.down('sm')]: {
    margin: 8,
    fontSize: '0.75rem'
  }
}))

export default BlackText
